const purchaseTickets = (ticketCount: number) => alert(`You've bought ${ticketCount} ticket(s)`);

export default purchaseTickets;
